import { useTranslation } from "@redotech/redo-i18n";
import { NumClaimsOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import type { NumCustomerClaimsState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const NumCustomerClaimsDetails = memo(function NumCustomerClaimsDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<NumCustomerClaimsState>) {
  const { t } = useTranslation();
  const claimOptions: RedoListItem<NumClaimsOption>[] = useMemo(
    () =>
      Object.values(NumClaimsOption).map((option) => ({
        id: option,
        value: option,
        type: "text" as const,
        text:
          option === NumClaimsOption.LESS_THAN
            ? t("Less than")
            : t("Greater than"),
      })),
    [t],
  );

  const selectedOption = state.claimOption
    ? claimOptions.find((option) => option.value === state.claimOption)
    : undefined;

  return (
    <>
      <RedoSingleSelectDropdownInput
        disabled={disabled}
        flexGrow
        label={t("Comparison")}
        options={claimOptions}
        optionSelected={({ item }) =>
          setState({ ...state, claimOption: item.value })
        }
        placeholder={t("Select comparison...")}
        selectedItem={selectedOption}
        size="xs"
      />
      <RedoTextInput
        label={t("Number of claims")}
        min={0}
        onBlur={() =>
          setState({ ...state, numClaims: (+state.numClaims).toFixed(0) })
        }
        setValue={(e) =>
          setState({
            ...state,
            numClaims: e,
            claimOption: state.claimOption || null,
          })
        }
        state={disabled ? "readonly" : "default"}
        value={state.numClaims}
      />
    </>
  );
});
